// import style from './terms.module.scss';
// import AppStore from "../../images/AppStore.png"
// import PlayStore from "../../images/PlayStore.png"
import termsAndCondition from '../../images/termsAndCondition.png';
import logoButton from '../../images/content.png';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import I18n from '../../lib/lingui/i18n';
import style from './terms.module.scss';
import buttom from '../../images/buttom.png';
import buttomMedia from '../../images/buttomMedia.png';
import logoPhonedo from '../../images/logo.png';

export const TermsAndCondition = () => {
  const history = useHistory();
  const [languageDirection, setLanguageDirection] = useState<string>();
  const [changeColor, setChangeColor] = useState<string>();

  useEffect(() => {
    if (window.location.pathname.includes('he') || window.location.pathname.includes('ar')) {
      setLanguageDirection('rtl');
    } else {
      setLanguageDirection('ltr');
    }
  }, []);
  return (
    <div>
      <div className={style.webSitebody}>
        <img className={style.firstBackround} src={termsAndCondition} alt={termsAndCondition} />
        <div
          className={style.section0}
          style={{ direction: languageDirection === 'rtl' ? 'rtl' : 'ltr' }}
        >
          <img
            className={
              languageDirection === 'rtl'
                ? style.rtllogoPhonedo.concat(' ').concat(style.logoPhonedo)
                : style.logoPhonedo
            }
            src={logoPhonedo}
            alt={logoPhonedo}
            onClick={() => {
              history.push('/');
            }}
          />
          <img
            className={languageDirection === 'rtl' ? style.logoButtonRtl : style.logoButton}
            src={logoButton}
            alt={'logoButton'}
            onClick={() => {
              history.push('/');
            }}
          />
          <img
            className={
              languageDirection === 'rtl'
                ? style.rtllogoPhonedo.concat(' ').concat(style.logoPhonedo)
                : style.logoPhonedo
            }
            src={logoPhonedo}
            alt={logoPhonedo}
          />
          <div className={style.space}></div>
        </div>
        <div className={style.section1}>
          <div
            className={
              languageDirection === 'rtl'
                ? style.rtlLanguage.concat(' ').concat(style.rapper)
                : style.rapper
            }
          >
            <div className={style.headerTerms}>
              <I18n t="Terms & Contidion" />
            </div>
            <div className={style.subheaderTerms}>
              <I18n t="Terms & Condition-PhoneDo" />
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          languageDirection === 'rtl'
            ? style.rtlLanguage.concat(' ').concat(style.flex)
            : style.flex
        }
        style={{ marginTop: '110px' }}
      >
        <div className={style.LeftSide}>
          <p className={style.round}>
            <div
              style={{ fontSize: '20px', lineHeight: '32px', height: '60px' }}
              onClick={() => {
                setChangeColor('1');
              }}
              className={changeColor === '1' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Terms of Service" />
            </div>
            <a
              href="#disclaimer-section"
              onClick={() => {
                setChangeColor('2');
              }}
              className={changeColor === '2' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Disclaimer" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#lastUpdated-section"
              onClick={() => {
                setChangeColor('3');
              }}
              className={changeColor === '3' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Last Updated on May 1, 2020" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#definitions-section"
              onClick={() => {
                setChangeColor('4');
              }}
              className={changeColor === '4' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Definitions" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#application-section"
              onClick={() => {
                setChangeColor('5');
              }}
              className={changeColor === '5' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Application" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#eligibility-section"
              onClick={() => {
                setChangeColor('6');
              }}
              className={changeColor === '6' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Eligibility" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#userAccounts-section"
              onClick={() => {
                setChangeColor('7');
              }}
              className={changeColor === '7' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="User Accounts" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#userContent-section"
              onClick={() => {
                setChangeColor('8');
              }}
              className={changeColor === '8' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="User content" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#originalContent-section"
              onClick={() => {
                setChangeColor('9');
              }}
              className={changeColor === '9' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Original Content" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#ownershipContent-section"
              onClick={() => {
                setChangeColor('10');
              }}
              className={changeColor === '10' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Ownership of Content" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#rightRemove-section"
              onClick={() => {
                setChangeColor('11');
              }}
              className={changeColor === '11' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Right to Remove" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#unauthorized-section"
              onClick={() => {
                setChangeColor('12');
              }}
              className={changeColor === '12' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Unauthorized usage of the App" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#businessAccounts-section"
              onClick={() => {
                setChangeColor('13');
              }}
              className={changeColor === '13' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Business accounts" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#paymentServices-section"
              onClick={() => {
                setChangeColor('14');
              }}
              className={changeColor === '14' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Payment for the Services" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#releaseCharges-section"
              onClick={() => {
                setChangeColor('15');
              }}
              className={changeColor === '15' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Release of Payments and Charges" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#refunds-section"
              onClick={() => {
                setChangeColor('16');
              }}
              className={changeColor === '16' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Refunds" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#freelancerAccounts-section"
              onClick={() => {
                setChangeColor('17');
              }}
              className={changeColor === '17' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Freelancer accounts" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#freelancer’sCompensation-section"
              onClick={() => {
                setChangeColor('18');
              }}
              className={changeColor === '18' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Freelancer’s Compensation" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#appIntermediary-section"
              onClick={() => {
                setChangeColor('19');
              }}
              className={changeColor === '19' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="App as an intermediary" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#calls-section"
              onClick={() => {
                setChangeColor('20');
              }}
              className={changeColor === '20' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Calls Held on the App" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#disputesBetweenUsers-section"
              onClick={() => {
                setChangeColor('21');
              }}
              className={changeColor === '21' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Disputes between users" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#serviceAvailability-section"
              onClick={() => {
                setChangeColor('22');
              }}
              className={changeColor === '22' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Service availability" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#linksApps-section"
              onClick={() => {
                setChangeColor('23');
              }}
              className={changeColor === '23' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Links to third party websites or apps" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#copyrights-section"
              onClick={() => {
                setChangeColor('24');
              }}
              className={changeColor === '24' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Copyrights & Intellectual property" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#legalDisclaimers-section"
              onClick={() => {
                setChangeColor('25');
              }}
              className={changeColor === '25' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Legal disclaimers" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#technicalIssues-section"
              onClick={() => {
                setChangeColor('26');
              }}
              className={changeColor === '26' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Technical issues" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#limitedLiability-section"
              onClick={() => {
                setChangeColor('27');
              }}
              className={changeColor === '27' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Limited liability" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#termination-section"
              onClick={() => {
                setChangeColor('28');
              }}
              className={changeColor === '28' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Termination" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#entireAgreement-section"
              onClick={() => {
                setChangeColor('29');
              }}
              className={changeColor === '29' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Entire agreement" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#severability-section"
              onClick={() => {
                setChangeColor('30');
              }}
              className={changeColor === '30' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Severability" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#waivers-section"
              onClick={() => {
                setChangeColor('31');
              }}
              className={changeColor === '31' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Waivers" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#choiceLawVenue-section"
              onClick={() => {
                setChangeColor('32');
              }}
              className={changeColor === '32' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Choice of law and venue" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#forceMajeureEvents-section"
              onClick={() => {
                setChangeColor('33');
              }}
              className={changeColor === '33' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Force majeure events" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#notices-section"
              onClick={() => {
                setChangeColor('34');
              }}
              className={changeColor === '34' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Notices" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#updates-section"
              onClick={() => {
                setChangeColor('35');
              }}
              className={changeColor === '35' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Updates" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#employerEmployeeRelationnship-section"
              onClick={() => {
                setChangeColor('36');
              }}
              className={changeColor === '36' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Employer employee relationnship" />
            </a>
            <p className={style.solid}></p>
            <a
              href="#taxes-section"
              onClick={() => {
                setChangeColor('37');
              }}
              className={changeColor === '37' ? style.onClicksideTitle : style.sideTitle}
            >
              <I18n t="Taxes" />
            </a>
            <p className={style.solid}></p>
          </p>
        </div>
        {languageDirection !== 'rtl' && (
          <div className={style.middle}>
            {/* <div id="my-section">Coming soon</div>
                    <a href="#my-section">Jump to my-section</a> */}
          </div>
        )}
        <div
          className={
            languageDirection === 'rtl'
              ? style.rtlLanguage.concat(' ').concat(style.RightSide)
              : style.RightSide
          }
        >
          {/* <h1>Right</h1> */}
          <div
            id="disclaimer-section"
            className={
              languageDirection === 'rtl'
                ? style.rtlLanguage.concat(' ').concat(style.title)
                : style.title
            }
          >
            <I18n t="Disclaimer" />:
          </div>
          <div className={style.articalBottom}>
            <div className={style.flexArtical}>
              <b>1.</b>
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="This document, and all Phonedo content, all sites, apps, platforms, and more Address all genders equally, although there may be formulas that are in male, or female, or any other formulation" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>2.</b>
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="There may be different duplicates or wording in the same contexts, or similar contexts, or in different contexts This document, and / or other documents But they do not detract from Phonedo rights but to add rights according to the most extended interpretation in its favor" />
              </div>
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="lastUpdated-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="Last Updated on May 1, 2020" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="Any visitor and / or user and / or business and / or telephone and / or service provider and / or / Partner / or/ affiliate /or q Investor who accesses the Website and / or downloads an application and / or is directly and / or indirectly assisted by the Website and / or Application and / Or any platform and / or service or multiple services, hereby declare that it voluntarily agrees – and without being subjected to or exercised by it, any emotional or physical manipulation – to any of the terms of use set forth in this document, and that the continued browsing and / or use of the site and / Or in any application and / or any other platform, it shall be deemed to sign an agreement to all terms of use and privacy policy and to all stated in this document R Phonedo Call Centers Ltd (the Company) is a private limited company based in the city of Jerusalem, in Israel The Company owns and manages a web application, mobile application or application on other platforms and devices entitled Phonedo, Phonedo, Fonedo, and more (collectively referred to as the App) The App is proprietary and exclusively owned by the Company The App provides an array of services available to its users, including but not limited to connecting businesses with freelancers Business may use the App to obtain assistance, translations and support during phone calls Through and using the App, freelancers may provide services to the businesses, including but not limited to answering calls, offering support and preparing translations\nThe present Terms and Conditions will govern the terms upon which businesses may use and purchase the services offered through the App and upon which freelancers may use the App to offer, deliver translations and similar services to businesses These Terms and Conditions apply to all users, both businesses and freelancers, who access, download or otherwise use the App, place a request for services, respond to any such requests and deliver the services" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="definitions-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="DEFINITIONS" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="The following terms, when used in these Terms and Conditions, including the above recitals, shall have the meanings set forth below, unless the context requires otherwise:“Business” shall refer to any business, organization or entity that uses the App to place Requests and to obtain Services offered by Freelancers“Company” shall refer to R Phonedo Call Centers Ltd, a limited company having its registered offices located at 3 Bruchim Street Jerusalem 9530803 Israel The Company may also be referred to as “we”, “us”, “our”, and other similar expressions“Freelancer” shall refer to any freelancer, agent or service provider using the App to offer and provide Services“Request” shall refer to any request for specific Services placed by the Business through the App The Request shall be placed according to the instructions detailed on the App and the purpose of the Request shall be to obtain Services from a qualified Freelancer“Services” shall refer to the services offered by Freelancers on the App The Services shall include, without limitation, human phone answering services, sales support, and live translations in a variety of languages“Terms and Conditions” shall refer to the latest applicable version of the present Terms and Conditions and includes any and all amendments and supplements made hereto from time to time“Users” shall refer to all users of the App, including the Businesses and the Freelancers Users may also be referred to as “you”, “your” and other similar expressions in these Terms and Conditions" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="application-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="APPLICATION" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="Your download and subsequent usage of the App shall constitute your acceptance of these Terms and Conditions These Terms and Conditions constitute an enforceable and binding agreement between you and the Company You acknowledge that the Company shall not be bound by any terms except for those detailed in these Terms and Conditions If you do not agree with these Terms and Conditions, in full or in part, your sole recourse shall be to delete and not use the App" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="eligibility-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="ELIGIBILITY" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="To be eligible to be use the App, whether offering or purchasing Services, you confirm that:– You are at least eighteen (18) years of age– You are not subject to any restrictions as to purchasing or providing Services on the App, as the case may be– Your download and usage of the App does not conflict with any order, judgment, agreement or relationship to which you are legally bound– If you are a Business, you confirm that you have not been barred from receiving or otherwise purchasing Services in the jurisdiction in which you are based– If you are a Freelancer, you confirm that you have not been barred from rendering Services in the jurisdiction in which you reside" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="userAccounts-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="USER ACCOUNTS" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="To use the App and benefit from the Services, whether as a Business or a Freelancer, you will be required to create a user account You may be required to provide personal information, such as your name, email address, contact information, payment information and other personal data to create your user account You agree that information you provide will be complete, true, accurate, and current If any information were to change, you will update the personal information saved under your user account You acknowledge that your user account is personal, and may not be used by any third party, except if you grant them explicit permission to do so You will be responsible for all activities and communications that come from your user account, unless you demonstrate that your account was subject to hacking or compromised You are further responsible for securing your user account with a strong password If you have reason to believe your password was compromised, you agree to immediately change your password and notify us of any potential security breaches or unauthorized use of your user account" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="userContent-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="USER CONTENT" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="As a User, you may be able to post content on the App, such as messages, photos, posts, videos, recordings and other postings" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="originalContent-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="Original Content" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="You are solely responsible for any content you post on the App You confirm that the content you publish on the App is your original work and is not plagiarized or in any way copied from a third party If the content is not your original work, you must obtain all necessary permissions and consents from the author of the content prior to publishing such content on the App You understand that you may be held personally liable if the content you post violates any third party right or intellectual property law Considering such content is uploaded by Users, we decline all responsibility for the User content published on the App We cannot offer any guarantees with respect to the legitimacy, integrity or quality of User content published on the App" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="ownershipContent-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="Ownership of Content" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="You agree that all content you publish on the App shall be our sole and exclusive property We shall hold all ownership and intellectual property rights connected to the content published on the App, even if the content has been subsequently removed or deleted Upon the upload or publication of content on the App, the User submitting such content agrees that the ownership of the content shall be transferred to us As such, we shall have the right to publish, post, upload, modify, reproduce, alter, commercialize, distribute, sell, lease, transfer or otherwise use the User content for purposes of the App, in any and all media or form of communication whether now existing or hereafter developed, without obtaining additional consent, and without restriction As the content uploaded on the App may be protected by copyright and intellectual property law, the uploading User shall grant and assign all copyright and corresponding ownership of the content to us, exclusively" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="rightRemove-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="Right to Remove" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="We reserve the right to remove, delete, or otherwise disable any content uploaded by a User if the content: (i) violates applicable laws, (ii) is of poor quality, (iii) is distasteful, unlawful, illegal, defamatory or otherwise problematic, as determined by us at our sole discretion, or (iv) infringes any provision contained in these Terms and Conditions" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="unauthorized-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="UNAUTHORIZED USAGE OF THE APP" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="You will be responsible for all actions, communications, publications and omissions in connection with your usage of the App While using the App, you may not engage, or attempt to engage, in any of the following behavior:• Using the App to violate or infringe any applicable law, regulation or policy, including all legislation applicable in the User’s country of residence;• Using the App for any unlawful or illegal purposes, or encouraging others to use the App for such purposes;• Publishing unauthorized, defamatory, illegal or inappropriate content on the App; • If a Business, refusing or neglecting to pay for Services that have been rendered, without the Company’s prior written permission; • If a Freelancer, refusing or neglecting to provide any Services that have been assigned to you, without valid justification;• Selling, assigning or otherwise transferring your user account, without having obtained the Company’s prior written permission;• Disseminating or distributing spam, unsolicited material or bulk communications, such as chain letters;• Transmitting any virus or material containing harmful components to Users or on the App; • Impersonating an individual or company, or otherwise misleading Users about your true identity in an effort to gain an unauthorized benefit or for deceptive purposes; • Collecting personal information about Users, without their valid and lawful consent;• Hacking, disassembling, or reverse engineering the App or any portion thereof;• Intentionally omitting to disclose personal information or relevant information to the Company or on the App;• Damaging, destroying, disabling or otherwise impairing the App or any portion thereof;• Pretending to be a partner or employee of the Company, or misleading other Users or individuals into believing that such is the case;• Engaging in behavior that is contrary to the intent of these Terms and Conditions The above list of prohibited conduct on the App is not exhaustive, and should be used for illustration and reference purposes, without being treated as the complete list of excluded and unauthorized behavior Users of the App are not permitted to engage or communicate with one another outside of the App with respect to any Services offered on the App or to circumvent using the App For avoidance of doubt, any purchase or delivery of Services between Users may only occur on the App, and on no other platform Any violation of this obligation may result in the suspension or deactivation of the violating User’s accounts" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="businessAccounts-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="Business accounts" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="Any Business wishing to purchase Services shall complete a Request according to the instructions set forth on the App The Request shall contain the Services requested, the desired price range and the anticipated dates for the performance of the Services Any Request by the Business shall be submitted on the App The App shall then present an estimate of the costs and a Freelancer whose profile complies with the requirements of the Business as listed in the Request To benefit from the Services and to submit Requests, the Business confirms and represents the following to the Company: The information provided in the Business’ user account is true, relevant, current and accurate, to the best of the Business’ knowledge The information and criteria listed by the Business in the Request is complete, lawful and does not violate these Terms and Conditions The Business has the required funds to purchase the Services, subject to the Request submitted The Business confirms that the Company and the Freelancer shall not be liable for the Business’ usage of the Services, or the results produced by or in connection with the Services The Business acknowledges that if the Business’ Request or purchase of Services breaches any third party right or legal obligation, we shall not be responsible" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="paymentServices-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="71 Payment for the Services" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="Upon the submission and subsequent acceptance of a Request, the Business shall receive an estimate of the costs for the Services The estimate shall be calculated based on the anticipated duration of the Services The Services shall be billed per minute spent by the Freelancer on a call The Business shall prepay for the Services at the price detailed in the estimate provided on the App If the Business’ account does not present a balance or if the Services have not been prepaid, the Request may be canceled or deleted, without penalty or liability The Business shall prepay for the Services using an authorized payment method, which may be a credit card, bank transfer or any other method authorized by the Company The Business confirms being the owner or authorized user of the credit card or account used to purchase the Services If the Business is not the owner of the payment method submitted, the Business has secured all legal and required consents to use such payment method The Company may refuse to process a Request if the payment method provided is invalid, expired, unusable or suspicious The sum listed in the estimate shall be withdrawn and held by the Company until the completion of the Services by the Freelancer Once the Services have been completed, the estimate shall be adjusted to reflect the actual cost of the Services, based on the number of minutes of the relevant call The funds to compensate the Services shall then be released to the Company and to the Freelancer, in the proportions agreed upon" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="releaseCharges-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="72 Release of Payments and Charges" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="The Business shall honor all charges in connection with the Services, as listed in the estimate and subsequent confirmation of costs The Business shall pay all applicable taxes and charges in connection with the Services purchased Unless otherwise indicated by us, the Business’ payment method and information shall remain on file to cover future payments of Services The Business shall be responsible for all Requests placed using the Business’ user account and payment method If the Business’ payment method has been hacked or compromised, the Business agrees to notify us immediately through the App" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="refunds-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="73 Refunds" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="All payments made by the Business for Services performed are final, and are not subject to refunds More specifically, we do not accept to grant refunds on the following grounds: quality of the Services, or issues with the Freelancer Any unused balance in the Business’ user account shall not be subject to a refund It is, however, possible for a Business to rate the Freelancer’s performance upon the completion of the Services The Business’ rating and feedback of the Freelancer shall be used by the Company for quality assurance and compliance" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="8 Freelancer accounts" />
            </div>
            <div
              id="freelancerAccounts-section"
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="Successful Freelancers are motivated, professional, punctual, and reliable To perform Services for Businesses, Freelancers shall submit their qualifications and profile containing their experience and language skills on the App We shall send notifications to Freelancers when their profile matches a Request Considering the time sensitive nature of Requests, we encourage Freelancers to respond to Requests rapidly For this reason, we encourage Freelancers to enable “push notifications” Upon accepting to perform Services pursuant to a Request, the Freelancer shall comply with the following: – The Freelancer shall respond to the Request in a timely manner – The Freelancer shall perform the Services with competence, skill and care – The Freelancer shall deliver the Services within the timeframe specified in the Request – The Freelancer shall communicate respectfully and professionally with the Business throughout the performance of the Services – The Freelancer acknowledges that the Freelancer is performing the Services as an independent contractor to the Business and to the Company Nothing in these Terms and Conditions shall be construed as creating an employment relationship between the Freelancer and the Company We reserve the right to not publicize or display a Freelancer’s profile on the App if we determine that the Freelancer is not competent, has too many Requests that are overdue or provide Services that are not up to par" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="freelancer’sCompensation-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="81 Freelancer’s Compensation" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="Upon the completion of the Services by the Freelancer pursuant to a Request, the Freelancer shall be entitled to a portion of the fees paid by the Business for the Services as compensation We shall submit the compensation to the Freelancer in the proportions agreed upon between the Freelancer and the Company The Freelancer shall be responsible for the payment of any taxes imposed on compensation received for the Services, such as income taxes and self-employment tax, to our full exclusion" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="appIntermediary-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="9 App as an intermediary" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="The App serves as an intermediary between Businesses and Freelancers, and allows Businesses to acquire Services by Freelancers featured on the App The Freelancers offering Services on the App are not our employees, rather, they are independent service providers As an intermediary, we cannot control the quality or the effectiveness of the Services provided While we use our best efforts to vet and select highly skilled and professional Freelancers, we do not perform the Services ourselves so we cannot control the outcome of the Services" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="calls-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="91 Calls Held on the App" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="As the Services may involve the Freelancer participating in a call with the Business, we ask that Users do not record any calls, content and activities held on the App, except with our explicit prior consent You are not authorized to sell, lease, transfer, assign, lend or otherwise share the calls, content and messages exchanged on the App with any third party You are not authorized to permit a third party to listen in on a call, without having obtained our prior written consent You acknowledge that we will have the ability to store, listen, and analyze all calls held through the App We will also retain the right to view, store and analyze messages, notifications and discussions held on the App This information may be provided and assigned to third parties by the Company for an audit or for another specific purpose The content of the calls, messages and discussions shall be available to us at all times, and we shall hold all ownership rights to all such content" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="disputesBetweenUsers-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="10 Disputes between users" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="In case of a dispute between Users, we invite the Users to resolve the dispute amicably between them If the dispute cannot be reasonably resolved, it should be submitted to us for review and handling We are not obligated to resolve any dispute between Users, but we will use our best efforts to secure a mutually-acceptable resolution of the dispute based on the facts and each User’s rights" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="serviceAvailability-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="11 Service availability" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="We shall use our best efforts to maintain a wide selection of Freelancers to fulfill the requirements of the Requests submitted, but we cannot guarantee that all Requests will be fulfilled in their entirety at all times We may be unable to process a Request, in whole or in part, due to the unavailability of Freelancers or concerns regarding the requirements If this is the case, we shall inform the Business, and we may offer an alternate Freelancer to fulfill the Request" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="linksApps-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="12 Links to third party Websites or Apps" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="The App may provide links to third party websites or applications The links to third party websites or applications provided on the App are solely for convenience Your usage of the third party website or applications is not subject to these Terms and Conditions Your usage of third party links, websites or applications is at your own risk and subject to the third party’s policies and terms" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="copyrights-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="13 Copyrights & Intellectual property" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="All or some content uploaded and / or published in the app Whether raised by us or by any of the permanent or temporary users are our absolute ownership and may be protected by copyright laws Trademarks, Trademarks or Intellectual Property All trademarks and intellectual property advertised in the app may be protected by intellectual property laws All rights pertaining to it are reserved You are also not authorized to copy and / or print portions of the Application for personal, non-commercial, and auxiliary purposes, unless otherwise authorized by us in writing We do not authorize copying, copying, modification or transfer of intellectual property in the app to any third party without our express prior written consent Any other use of copyrighted content is strictly prohibited" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="legalDisclaimers-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="14 Legal disclaimers" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="The App and its features are provided “as is” basis without warranties or guarantees of any nature, such as implied warranties, non-infringement, and fitness for a particular purpose, all of which are expressly excluded We do not guarantee that the App will produce any particular result with respect to the Request, or the Services We are not responsible for any issues, or conflict arising out of a Request, the Services and/or involving a Business, a Freelancer, or other User" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="technicalIssues-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="15 Technical Issues" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="Technical issues and problems may arise when using the App These issues may cause your usage of the App to be suspended, delayed or terminated, even may even freeze the device on which you are operating the App The App is continuously monitored to ensure its proper functioning but we cannot guarantee that your usage of the App be uninterrupted and without error at all times" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="limitedLiability-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="16 Limited liability" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="We shall not be held responsible for any damages, costs, expenses, proceedings or other claims related to the use or inability to use the App and its features You agree that your usage of the App is at your own risk and expense To the extent permitted by applicable law, we exclude all liability for losses, expenses, damages, claims and proceedings of any nature, including but not limited to direct damages, lost profits, loss of opportunity, punitive and incidental damages, even if we have been advised of the possibility of such damages, arising out of the use of the App This exclusion of liability remains applicable, regardless of the basis of the liability, whether in contract, negligence, misconduct, strict liability or another theory of law" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="termination-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="17 Termination" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="We may cancel or terminate your user account, a Request, the Services, in whole or in part, and with or without notice, at any time at our sole discretion We may terminate a Business’ user account if there are issues with payment, or if the Business failed or neglected to pay the costs payable for Services rendered due on their due date The termination shall not relieve the Business of its obligation to pay the sums due and all interest incurred, if applicable We may terminate a Freelancer’s user account if the Services provided are of poor quality, or if the Freelancer is uncooperative or unprofessional We shall not be liable to you for any termination or suspension of your user account, a Request, or the Services and you shall have no claims or recourses against us for any termination, whether with cause or without You may terminate or deactivate your user account at any time by sending us a notice to this effect in accordance with these Terms and Conditions Your user account will be immediately terminated upon our receipt of your termination notice All ongoing provisions of these Terms and Conditions shall survive termination of your user account, including, without limitation, content ownership provisions, legal disclaimers, and limitations of liability" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="entireAgreement-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="18 Entire agreement" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="These Terms and Conditions, together with any document referred to herein, constitutes the entire agreement between you and us with respect to the subject matter hereof These Terms and Conditions shall all previous negotiations and agreements between you and us regarding such subject matter" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="severability-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="19 Severability" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="If any provision in these Terms and Conditions is held invalid or unenforceable by a competent court of law or by valid authority, the provision in question shall be severed from these Terms and Conditions The remaining provisions shall remain valid, binding and applicable" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="waivers-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="20 Waivers" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="If we do not exercise or delay any right or privilege under these Terms and Conditions, this shall not be construed or interpreted as a waiver of our rights" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="choiceLawVenue-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="21 Choice of law & venue" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="These Terms and Conditions are governed by the laws of Israel The competent courts located in Israel shall have exclusive jurisdiction over any and all disputes relating to the validity, interpretation, and performance of the Services and any matters covered by these Terms and Conditions" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="forceMajeureEvents-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="22 Force majeure events" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="Force Majeure events are unpredictable and grave situations beyond our reasonable control, which include wars, government acts, hurricanes, floods, or other natural disasters Our obligations under these Terms and Conditions shall be suspended for the duration of a Force Majeure event If the Force Majeure event persists for a reasonable duration, as determined by us at our discretion, we reserve the right to terminate any and all Requests, Services, your user account or your access to the App without liability" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="notices-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="23 Notices" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="You may send us any notices by email or through the App You may receive notices regarding the App, your user account, the Services and/or a Request These notices shall be sent to you by email or via a notification on the App Considering we may communicate with you by email, you are responsible for providing your email address If the email address you provided is invalid, any notice sent to this email shall be deemed valid and properly delivered" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="updates-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="24 Updates" />
            </div>
            <div
              className={`${languageDirection === 'rtl' ? style.articalRtl : style.artical} ${
                style.flexArtical
              }`}
            >
              <I18n t="We may update or modify these Terms and Conditions without notice, at our discretion The latest version of these Terms and Conditions shall be available for review on the App We suggest you read the Terms and Conditions periodically to ensure familiarity with the latest version Your continued access to or use of the App following any modifications made to these Terms and Conditions shall constitute your acceptance of the updated Terms and Conditions" />
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="employerEmployeeRelationnship-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="EMPLOYER-EMPLOYEE RELATIONSHIP" />
            </div>
            <div className={style.flexArtical}>
              <b>1.</b>
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="The various users, and the customers, and the suppliers, and the partners, and the Freelancers, and the business, and the investors, hereby declare that no employee-employer relationship exists between them and Phonedo" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>2.</b>
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="The various users, and the customers, and the suppliers, and the partners, and the Freelancers, and the business, and the investors, hereby declare that no employee-employer relationship exists between them and Phonedo The various users, and the customers, and the suppliers, and the partners, and the Freelancers, and the business, and the investors, will not be able to obtain social or other employee rights in the future" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>3.</b>{' '}
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="The various users, and the customers, and the suppliers, and the partners, and the Freelancers, and the business, and the investors, hereby declare that the payments they receive from Phonedo constitute full and final consideration for the service providers services, and shall not be entitled to any additional consideration or payment of any kind It should be clarified in this regard that if a claim or demand is made in the future for the payment of any social right as a salaried employee, payments received shall be deemed to include full rights – and in particular travel and recovery fees – and in any case the excess proceeds received as a service provider shall be deemed to be offset by the rights they were entitled to, if he determines he is eligible" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>4.</b>{' '}
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="This Agreement constitutes a contract for the provision of services, and as such, exclusively governs all contractual terms of service and all that is involved therewith" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>5.</b>
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="This Agreement is exhaustive of the legal relationship between the parties and supersedes any contract, arrangement, agreement, negotiation, exchange, understanding, undertaking or representation which, if any, were in writing or orally, between the parties prior to the signing of this contract" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>6.</b>{' '}
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="The various users, and the customers, and the suppliers, and the partners, and the Freelancers, and the business, and the investors, hereby declare that they have the requisite job requirements and skills to perform their duties and that they have the knowledge, skills, experience and skill to perform their duties to the best of their ability and to the satisfaction of the users and customers And the other partners" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>7.</b>{' '}
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="The various users, and the customers, and the suppliers, and the partners, and the Freelancers, and the business, hereby declare that there is no contractual and / or legal impediment to their contracting in this contract and / or performing their duties on the best side" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>8.</b>
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="The various users, and the customers, and the suppliers, and the partners, and the Freelancers, and the business, and the investors, hereby declare that they have no objection to service to other parties, provided that they do not compete with the customer in any way" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>9.</b>{' '}
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="The various users, and the customers, and the suppliers, and the partners, and the Freelancers, and the business, and the investors, hereby undertake to comply with the Companys procedures in accordance with all written in this document as well as all updates that will be added from time to time Appendix to procedures attached to this Agreement, which shall be updated from time to time" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>10.</b>{' '}
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="The various users, and the customers, and the suppliers, and the partners, and the Freelancers, and the business, and the investors, hereby pledge to insure their wages for loss of work skills or a pension fund that includes a loss of work capacity Phonedo may be authorized to periodically verify the existence of the insurance" />
              </div>
            </div>
          </div>
          <div className={style.articalBottom}>
            <div
              id="taxes-section"
              className={
                languageDirection === 'rtl'
                  ? style.rtlLanguage.concat(' ').concat(style.title)
                  : style.title
              }
            >
              <I18n t="TAXES" />
            </div>
            <div className={style.flexArtical}>
              <b>1.</b>
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="R Phonedo Call Centers Ltd is an Israeli company and is bound by all Israeli tax laws" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>2.</b>
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="The various users, and the customers, and the suppliers, and the partners, and the Freelancers, and the business, and the investors, of Phonedo are aware that no employee-employer relationship exists with Phonedo" />
              </div>
            </div>

            <div className={style.flexArtical}>
              <b>3.</b>{' '}
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="Phonedo does not tax withholding But will do so when obligated by law to do so" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>4.</b>{' '}
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="Phonedo does not Deduct VAT taxes from payments initiated to users and customers and suppliers and partners but will do so when obligated by law to do so" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>5.</b>
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="Phonedo does not Deduct Social Security payments From payments initiated to users and customers and suppliers and partners but will do so when obligated by law to do so" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>6.</b>{' '}
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="All amounts that Phonedo pays to its suppliers are net payments before deducting any tax payments" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>7.</b>{' '}
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="The various users, and the customers, and the suppliers, and the partners, and the Freelancers, and the business, and the investors, hereby declare that they are responsible for reporting to the various tax authorities in their state of residence all their income and expenses in any connection to the Phonedo Company" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>8.</b>
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="Phonedo may at any time request a tax exemption clearance and hold funds until the certificate is duly obtained" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>9.</b>{' '}
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="The various users, and the customers, and the suppliers, and the partners, and the Freelancers, and the business, and the investors, undertake to fully comply with all lawful obligations" />
              </div>
            </div>
            <div className={style.flexArtical}>
              <b>10.</b>
              <div className={languageDirection === 'rtl' ? style.articalRtl : style.artical}>
                <I18n t="Phonedo will collect VAT payments lawfully from each user and customers, and suppliers, and partners, and Freelancers, and business, and the investors, for a service or product that was been purchase through Phonedo" />{' '}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={style.articalBottom}>
        <div id="section11" className={style.section11}>
          <img className={style.buttom} src={buttom} alt={buttom} />
          <img className={style.buttomMedia} src={buttomMedia} alt={buttomMedia} />
          <div className={style.rapper1}>
            <div className={style.header1}>
              <I18n t="Create better experiences with Phonedo Mobile app" />
            </div>
            <button
              className={style.smallButton1}
              onClick={() => {
                history.push(`/${window.location.pathname.slice(1, 3)}/registration/verify-phone/`);
              }}
            >
              <I18n t="Let's Do it!" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
